/** Normalize web OTA / bundle version strings for equality checks (trim, strip leading #). */
export function normalizeWebOtaVersionToken(raw: string): string {
  return raw.trim().replace(/^#+/, '')
}
